module.exports = __webpack_public_path__ + "static/media/tapir-black.d063184d.png";